/**
 * Show or hide menu background
 */

let debug = false;

/**
 * Function to reset starting positions
 */
window.onresize = function () {
    if (debug) {
        console.log("resetSliderPositions")
    }
    setRangeSliderPositions()
}

/**
 * Function animate circle
 */
let circle = document.getElementById('circle-animation')
if (circle) {
    let circleOffset = circle.offsetTop
    window.addEventListener('scroll', function () {
        if (document.documentElement.scrollIntoView) {
            setTimeout(function() {
                circle.classList.add('animate')
            }, 2000);
        }
    })
}

/**
 * Home Range Slider - Top Content
 */
let windowWidth, sliderQuoteMargin, sliderWidth, sliderTotalWith, startPos, isDown, lastPos

const rangeSlider = document.querySelector('.range-slider')
const quotes = document.getElementById('quotes-container')

function setRangeSliderPositions() {
    if (debug) {
        console.log("run setRangeSliderPositions")
    }

    windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth // width of the visible window

    let isMobile = window.matchMedia("only screen and (max-width: 767px)");

    sliderQuoteMargin = 110
    sliderWidth = 460 // slider with in pixel

    if (isMobile.matches) {
        sliderWidth = 340
        sliderQuoteMargin = 60
    }

    sliderTotalWith = sliderWidth + sliderQuoteMargin

    startPos = (windowWidth / 2) - (sliderWidth / 2)

    isDown = false
    lastPos = startPos

    rangeValueHandler()
}

setRangeSliderPositions()

function dragHandler() {
    //console.log("range slider mousedown or mouseup")
    isDown = !isDown;
    if (!isDown) {

    } else {

    }
}

function dragOn(e) {
    //console.log("range slider mousemove + value" + rangeSlider.value)
    if (!isDown) return;
    rangeValueHandler();
}

function rangeValueHandlerMobile() {
    //console.log("range slider touchmove")
    if (rangeSlider != null) {
        lastPos = startPos - sliderTotalWith * parseInt(rangeSlider.value)
        quotes.style.left = lastPos + "px"
    }
}

function rangeValueHandler() {
    //console.log("range slider click")
    if (rangeSlider != null) {
        lastPos = startPos - sliderTotalWith * parseInt(rangeSlider.value)
        quotes.style.left = lastPos + "px"
    }
}

function rangeSliderUpdate() {
    //console.log("range slider update")
}

rangeValueHandler();

if (rangeSlider != null) {
    rangeSlider.addEventListener('mousedown', dragHandler);
    rangeSlider.addEventListener('mousemove', dragOn);
    rangeSlider.addEventListener('touchmove', rangeValueHandlerMobile);
    rangeSlider.addEventListener('mouseup', dragHandler);
    rangeSlider.addEventListener('click', rangeValueHandler);
}

/**
 * function scroll to.. id / anchor
 */
let scrollButton = document.getElementById('scroll-btn')
let scrollView = document.getElementById('scroll-view')
/*if (scrollButton != null) {
    scrollButton.addEventListener("click", function () {
        //scrollToAnchor()
        //scrollToAnchorFullSupported()

    });
}*/

function scrollToAnchorFullSupported() {
    scrollIntoView(scrollView, {
        behavior: 'smooth',
        scrollMode: 'if-needed',
        block: 'nearest',
        inline: 'nearest',
    })
}

function scrollToAnchor() {
    if (debug) {
        console.log("scroll to anchor")
    }
    if(scrollView.scrollIntoViewIfNeeded){
        scrollView.scrollIntoViewIfNeeded({

        })
    }else{
        scrollView.scrollIntoView({
            top: scrollView.offsetTop - 72,
            left: 0,
            behavior: 'smooth'
        })
    }
    //scrollView.scrollIntoView({ block: 'start', behavior: 'smooth' })
/*    setTimeout(function () {
        window.scrollTo({
            top: scrollView.offsetTop - 72,
            left: 0,
            behavior: "smooth"
        })
    }, 100);*/
    //Gentle_Anchors.Setup('scroll-view')
}

// easing functions http://goo.gl/5HLl8
Math.easeInOutQuad = function(t, b, c, d) {
    t /= d / 2;
    if (t < 1) {
        return c / 2 * t * t + b
    }
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
};

Math.easeInCubic = function(t, b, c, d) {
    let tc = (t /= d) * t * t;
    return b + c * (tc);
};

Math.inOutQuintic = function(t, b, c, d) {
    let ts = (t /= d) * t,
        tc = ts * t;
    return b + c * (6 * tc * ts + -15 * ts * ts + 10 * tc);
};

// requestAnimationFrame for Smart Animating http://goo.gl/sx5sts
let requestAnimFrame = (function() {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(callback) {
        window.setTimeout(callback, 1000 / 60);
    };
})();

function scrollTo(to, callback, duration) {
    // because it's so fucking difficult to detect the scrolling element, just move them all
    function move(amount) {
        document.documentElement.scrollTop = amount;
        document.body.parentNode.scrollTop = amount;
        document.body.scrollTop = amount;
    }

    function position() {
        return document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
    }
    let start = position(),
        change = to - start,
        currentTime = 0,
        increment = 20;
    duration = (typeof(duration) === 'undefined') ? 500 : duration;
    let animateScroll = function() {
        // increment the time
        currentTime += increment;
        // find the value with the quadratic in-out easing function
        let val = Math.easeInOutQuad(currentTime, start, change, duration);
        // move the document.body
        move(val);
        // do the animation unless its over
        if (currentTime < duration) {
            requestAnimFrame(animateScroll);
        } else {
            if (callback && typeof(callback) === 'function') {
                // the animation is done so lets callback
                callback();
            }
        }
    };
    animateScroll();
}

if (scrollButton != null) {
    scrollButton.addEventListener('click', e => {
        const {
            target
        } = e;
        const to = target.getAttribute('data-target');
        const element = document.getElementById(to);
        const bodyRect = document.body.getBoundingClientRect();
        const elemRect = element.getBoundingClientRect();
        const offset = elemRect.top - bodyRect.top - 72;
        scrollTo(offset, null, 300);
    });
}

